import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'
import { faPlus, faSchool } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../../../../Components/shared/Forms/FormItem'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import { isDescribedSchool, School } from '../../../../utils/entities/school'
import { getEntityOrNull, getIdOrNull } from '../../../../utils'
import SchoolsSelector from '../../../../Components/shared/Selectors/School/SchoolsSelector'
import { SchoolModalContext } from '../../SchoolModal'
import PortalSchoolModal from './PortalSchoolModal'
import SchoolCard from '../../../../Components/shared/Schools/SchoolCard'

const SchoolPicker = ({ countries, data, described, errorFields, schools, title, onChange }) => {
  const t = useSelector(selectTranslate)
  const { setFormHandler } = useContext(SchoolModalContext)

  const options = useMemo(() => described === null ? schools : [...schools, described], [schools, described])

  const handleSelectSchool = (value, _, entity) => onChange(new School({ ...getEntityOrNull(entity) ?? getEntityOrNull(value) }))

  const openModal = school => setFormHandler(handler => ({ ...handler, data: school, callback: onChange }))

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  const renderDropdown = () => menu => (
    <div>
      {menu}
      <div className='flex-col m-4' onMouseDown={e => e.preventDefault()}>
        <IconButton
          text={t('internship_request_portal.school.create_button')}
          icon={faPlus}
          onClick={() => openModal(new School())}
        />
      </div>
    </div>
  )

  const hasSchool = described !== null || getIdOrNull(data) !== -1

  return (
    <>
      <FormItem icon={faSchool} label={title || 'common.school.dd'} className={'form-select ' + className('id')} required>
        <SchoolsSelector
          schools={options}
          multiple='default'
          values={hasSchool ? getIdOrNull(data) : null}
          dropdownRender={renderDropdown}
          onChange={handleSelectSchool}
        />
      </FormItem>

      {hasSchool && (
        <SchoolCard
          countries={countries}
          school={data}
          onEdit={() => openModal(new School(data))}
        />
      )}
    </>
  )
}

const SchoolSelector = ({ countries = [], data, displayTitle, errorFields = [], schools = [], title, onChange }) => {
  const t = useSelector(selectTranslate)

  const described = isDescribedSchool(data) ? data : null

  return (
    <>
      {displayTitle && <h3 className='pdl-12'> {t('common.school')}</h3>}

      <div className='pd-12'>
        <PortalSchoolModal countries={countries} schools={schools}>
          <SchoolPicker
            countries={countries}
            data={data}
            described={described}
            errorFields={errorFields}
            schools={schools}
            title={title}
            onChange={onChange}
          />
        </PortalSchoolModal>
      </div>
    </>
  )
}

export default SchoolSelector
